import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitMarch20KmResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitMarch20KmResultInput;
}>;


export type SubmitMarch20KmResultMutation = (
  { __typename: 'Mutation' }
  & { submitMarch20KmResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitMarch20KmResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & March20kmAssessmentResultFragment
    )> }
  ) }
);

export type March20kmAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'CardioRespResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | (
    { __typename: 'March20kmResult' }
    & March20kmAssessmentResultDataFragment
  ) | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SocResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | { __typename: 'WeightResult' } }
);

export type March20kmAssessmentResultDataFragment = (
  { __typename: 'March20kmResult' }
  & Pick<SchemaTypes.March20kmResult, 'timingSec' | 'result'>
);

export const March20kmAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment March20kmAssessmentResultData on March20kmResult {
  timingSec
  result
}
    `;
export const March20kmAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment March20kmAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on March20kmResult {
      ...March20kmAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitMarch20KmResultDocument = /*#__PURE__*/ gql`
    mutation SubmitMarch20KmResult($input: SubmitMarch20KmResultInput!) {
  submitMarch20KmResult(input: $input) {
    ... on SubmitMarch20KmResultSuccessfulResponse {
      result {
        ...March20kmAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${March20kmAssessmentResultFragmentDoc}
${March20kmAssessmentResultDataFragmentDoc}`;
export type SubmitMarch20KmResultMutationFn = Apollo.MutationFunction<SubmitMarch20KmResultMutation, SubmitMarch20KmResultMutationVariables>;

/**
 * __useSubmitMarch20KmResultMutation__
 *
 * To run a mutation, you first call `useSubmitMarch20KmResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMarch20KmResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMarch20KmResultMutation, { data, loading, error }] = useSubmitMarch20KmResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMarch20KmResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMarch20KmResultMutation, SubmitMarch20KmResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMarch20KmResultMutation, SubmitMarch20KmResultMutationVariables>(SubmitMarch20KmResultDocument, options);
      }
export type SubmitMarch20KmResultMutationHookResult = ReturnType<typeof useSubmitMarch20KmResultMutation>;
export type SubmitMarch20KmResultMutationResult = Apollo.MutationResult<SubmitMarch20KmResultMutation>;
export type SubmitMarch20KmResultMutationOptions = Apollo.BaseMutationOptions<SubmitMarch20KmResultMutation, SubmitMarch20KmResultMutationVariables>;